import i18n from 'i18next';

// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('createArticle', {
    parent: 'main',
    url: '/create-article?customerId&conceptId',
    views: {
      'main-content': {
        template:
          '<create-article-page customer-id="vm.customerId" concept-id="vm.conceptId"></create-article-page>',
        controller: 'CopyArticlePageController as vm',
      },
    },
    data: { pageTitle: i18n.t('article.create.title') },
  });

  $stateProvider.state('copyArticle', {
    parent: 'main',
    url: '/copy-article?sourceArticleId&customerId&conceptId',
    views: {
      'main-content': {
        template: `
          <copy-article-page
            source-article-id="vm.sourceArticleId"
            customer-id="vm.customerId"
            concept-id="vm.conceptId"
          ></copy-article-page>
        `,
        controller: 'CopyArticlePageController as vm',
      },
    },
    data: { pageTitle: 'Copy article' },
  });

  $stateProvider.state('article.management', {
    url: '/management',
    templateUrl: 'main/article/management/management.tpl.html',
    controller: 'ArticleManagementController as vm',
  });
};

class ArticleManagementController {
  constructor($rootScope, $state, article, ArticleDialogService) {
    'ngInject';

    $rootScope.pageTitle = `${article.itemCode || ''} - Management`;

    this.$state = $state;
    this.article = article;
    this.ArticleDialogService = ArticleDialogService;
    this.openConfiguration = () => this.configure();
    this.openCopyArticle = () => this.copyArticle();
  }

  copyArticle() {
    this.$state.go('copyArticle', {
      sourceArticleId: this.article.id,
      customerId: this.article.customerId,
      conceptId: this.article.conceptId,
    });
  }

  configure() {
    if (!this.hasMatrixNodes()) return;

    this.ArticleDialogService.showDialog({ article: this.article });
  }

  hasMatrixNodes() {
    return (
      !!this.article.matrixNodeX?.matrixNodeValues &&
      !!this.article.matrixNodeY?.matrixNodeValues
    );
  }
}

class CopyArticlePageController {
  constructor($stateParams) {
    'ngInject';

    this.sourceArticleId = this.parseId($stateParams.sourceArticleId);
    this.customerId = this.parseId($stateParams.customerId);
    this.conceptId = this.parseId($stateParams.conceptId);
  }

  parseId(value) {
    const id = Number(value);
    return Number.isFinite(id) && id > 0 ? id : undefined;
  }
}

angular
  .module('main.article.management', [])
  .config(config)
  .controller('ArticleManagementController', ArticleManagementController)
  .controller('CopyArticlePageController', CopyArticlePageController);
